export const returnQuanity = (array) => {
  let a = 0;
  (array || []).forEach((e) => {
    a += e.quantity;
  });
  return Number(a) > 0 ? a : '';
};

export const backgroundChange = (screen, btnColor) => {
  let buttonColor = '';
  if (screen) {
    buttonColor = screen;
  } else if (btnColor) {
    buttonColor = btnColor;
  }
  return buttonColor;
};

export const showPrice = (data, LABEL) => {
  return data && `${LABEL().CURRENCY_SYMBOL}${(data.price).toFixed(2)}`;
};
